import { dt } from '@primeuix/themes';

/**
 * Extends the css for all accordions so they have a full border radius when not active
 * but remove the bottom radius when active
 * @param param0
 * @param param0.dt
 * @returns
 */
const cssExtension = ({ dt }: any): string => `
.p-accordionpanel-active .p-accordionheader {
  border-bottom-left-radius: ${dt('accordion.extend.sd.header.active.border.bottom.left.radius')};
  border-bottom-right-radius: ${dt('accordion.extend.sd.header.active.border.bottom.right.radius')};
}

.p-accordioncontent-content {
  border-top-width: ${dt('accordion.extend.sd.content.border.top.width')} !important;
  border-bottom-left-radius: ${dt('accordion.extend.sd.content.border.radius')};
  border-bottom-right-radius: ${dt('accordion.extend.sd.content.border.radius')};
}

.p-accordionpanel {
  margin-top: 20px;
  padding: 0 16px;
}

.claims-mapping-accordion .p-accordionpanel {
  padding: 0 0;
}
`;

const customAccordionTokens = {
  container: {
    margin: '20px'
  },
  content: {
    border: {
      radius: '{sd.border.radius.medium}',
      top: {
        width: '0'
      }
    }
  },
  panel: {
    padding: '0 16px'
  },
  header: {
    active: {
      border: {
        bottom: {
          color: '{surface.300}',
          left: {
            radius: '0'
          },
          right: {
            radius: '0'
          }
        }
      }
    }
  }
};

const accordionContent = {
  padding: '1rem .5rem',
  border: {
    width: '1px',
    color: '{surface.300}'
  }
};

const accordionHeader = {
  active: {
    background: '{surface.50}',
    hover: {
      background: '{surface.50}'
    }
  },
  padding: '.875rem 1rem',
  first: {
    borderWidth: '1px'
  },
  border: {
    radius: '{sd.border.radius.medium}',
    width: '1px',
    color: '{surface.300}'
  },
  hover: {
    background: '{surface.50}'
  },
  background: '{surface.50',
  color: '{sd.text.primary}'
};

export const accordionTheme = {
  content: accordionContent,
  header: accordionHeader,
  extend: {
    panel: {
      padding: '0',
      border: {
        width: '0'
      }
    },
    sd: customAccordionTokens,
    css: cssExtension
  }
};
